import React from 'react';
import { ChevronDown, ChevronRight, MapPin } from 'lucide-react';
import DepartmentNode from '@/components/settings/DepartmentNode';

export default function LocationNode({
  company,
  location,
  departments = [],
  expanded,
  onToggle,
  renderDepartment,
  renderLocation,
  compact = false,
}) {
  return (
    <section className="border-t border-stone-100 first:border-t-0" data-testid={`settings-location-${location.id}`}>
      <div className={`flex flex-col ${compact ? 'gap-1 px-3 py-2' : 'gap-2 px-4 py-3 sm:px-5'}`}>
        <div className="flex min-w-0 items-start gap-2">
          <button
            type="button"
            className={`flex min-w-0 flex-1 text-left transition-colors hover:text-stone-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-emerald-200 ${compact ? 'items-center gap-2' : 'items-start gap-3'}`}
            aria-expanded={expanded}
            onClick={onToggle}
            data-testid={`settings-toggle-location-${location.id}`}
          >
            {expanded ? <ChevronDown className={`${compact ? '' : 'mt-0.5'} h-4 w-4 shrink-0 text-stone-400`} aria-hidden="true" /> : <ChevronRight className={`${compact ? '' : 'mt-0.5'} h-4 w-4 shrink-0 text-stone-400`} aria-hidden="true" />}
            <MapPin className={`${compact ? '' : 'mt-0.5'} h-4 w-4 shrink-0 text-brand-blue`} aria-hidden="true" />
            <span className="min-w-0 flex-1">
              <span className={`block break-words font-semibold text-stone-800 ${compact ? 'text-sm' : ''}`}>{location.name}</span>
              {!compact && location.code && <span className="block break-words text-xs text-stone-500">Codice: {location.code}</span>}
            </span>
            <span className={`shrink-0 text-right text-xs text-stone-400 ${compact ? '' : 'pt-0.5'}`}>{departments.length} {departments.length === 1 ? 'reparto' : 'reparti'}</span>
          </button>
        </div>
        {renderLocation?.({ company, location })}
      </div>
      {expanded && (
        departments.length ? (
          <div className="border-t border-stone-100 bg-white/60">
            {departments.map((department) => (
              <DepartmentNode key={department.id} company={company} location={location} department={department} compact={compact}>
                {renderDepartment?.({ company, location, department })}
              </DepartmentNode>
            ))}
          </div>
        ) : (
          <div className="px-11 pb-4 text-sm text-stone-500">Nessun reparto disponibile.</div>
        )
      )}
    </section>
  );
}